import { ReactComponent as Empty } from "../../../../../common/assets/icons/empty.svg";
import Toggle from "../../../../components/common/toggle";
import CheckBox from "../../../../components/common/checkBox";
import { ReactComponent as Dropdown } from "../../../../assets/icons/dropdown.svg";
import { ProductData } from "../../../../../common/hooks/console/management/goods/useGetGoods";
import { useEffect, useRef, useState } from "react";
import { usePutGoodsStatus } from "../../../../../common/hooks/console/management/goods/usePutGoodsStatus";
import { api_uri } from "../../../../../common/hooks/utils/enum";
import { useAuthStore } from "../../../../store/useAuthStore";

interface GoodsTableProps {
    data?: ProductData[];
    onSortChange?: (field: string) => void;
    onRowClick?: (idx: number) => void;
    onSelectionChange?: (selectedIds: number[]) => void;
    isNewGoods?: boolean;
    idx?: number;
    /* 삭제건 보기에서는 등록일자 자리에 삭제일자를 보여준다 */
    showDeleted?: boolean;
}
const GoodsTable = ({ data = [], onSortChange, onRowClick, onSelectionChange, isNewGoods, idx, showDeleted }: GoodsTableProps) => {
    const level = useAuthStore(state => state.m_level);

    const [selectedItems, setSelectedItems] = useState<number[]>([]);
    const isFirstRender = useRef(true);
    const putGoodsStatusMutation = usePutGoodsStatus();

    const handleChangeStatus = (id: number) => {
        const payload = {
            id,
        };
        putGoodsStatusMutation.mutate(payload);
    };

    const handleSelectItem = (idx: number) => {
        setSelectedItems(prev => {
            const newSelection = prev.includes(idx) ? prev.filter(id => id !== idx) : [...prev, idx];
            onSelectionChange?.(newSelection);
            return newSelection;
        });
    };

    const allSelected = data.length > 0 && selectedItems.length === data.length;
    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedItems([]);
            onSelectionChange?.([]);
        } else {
            const allIds = data.map(product => product.product_idx);
            setSelectedItems(allIds);
            onSelectionChange?.(allIds);
        }
    };

    // useEffect(() => {
    //     if (isFirstRender.current && data.length > 0) {
    //         isFirstRender.current = false;
    //         onRowClick?.(data[0].product_idx);
    //     }
    // }, [data]);
    return (
        <div className="h-full overflow-auto">
            <table className="table-auto w-full text-gray2">
                {/* Header */}
                <thead className=" text-sm border-y border-gray3 h-10">
                    <tr>
                        <th className="px-3">
                            <CheckBox checked={allSelected} onChange={handleSelectAll} />
                        </th>
                        <th className="px-2 text-start w-1/2">
                            <div className="flex items-center justify-between">
                                <p>카테고리</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSortChange?.("product_category")} />
                            </div>
                        </th>
                        <th className="px-2 text-start min-w-[80px] w-[80px]">상품코드</th>
                        <th className="px-2 text-start w-1/2">
                            <div className="flex items-center justify-between">
                                <p>상품명</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSortChange?.("product_name")} />
                            </div>
                        </th>
                        <th className="px-2 text-start min-w-[120px]">
                            <div className="flex items-center justify-between">
                                <p>가격</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSortChange?.("product_amount")} />
                            </div>
                        </th>
                        <th className="px-2 text-start min-w-[120px]">
                            <div className="flex items-center justify-between">
                                <p>{showDeleted ? "삭제일자" : "등록일자"}</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSortChange?.("reg_date")} />
                            </div>
                        </th>
                        {/*
                        // 삭제된 상품은 어디에도 노출되지 않으므로 이 컬럼이 의미가 없다.
                        // 토글해도 서버가 삭제건을 받지 않아 실패한다. (productStatus 는 is_delete='N' 만 조회)
                        */}
                        {!showDeleted && <th className="px-2 text-start min-w-[100px]">노출/숨김</th>}
                    </tr>
                </thead>
                {/* Body */}
                <tbody>
                    {data.length > 0 ? (
                        data?.map(product => (
                            <tr
                                key={product.product_idx}
                                className={`border-b border-gray4 text-sm h-[50px] cursor-pointer hover:bg-[#E6EEDD] ${isNewGoods || idx !== product.product_idx ? "" : "bg-[#F9EBEB]"}`}
                                onClick={e => {
                                    if (!(e.target as HTMLElement).closest(".checkbox-container")) {
                                        onRowClick?.(product.product_idx);
                                    }
                                }}
                            >
                                <td className="px-3 checkbox-container" onClick={e => e.stopPropagation()}>
                                    <CheckBox
                                        checked={selectedItems.includes(product.product_idx)}
                                        onChange={() => handleSelectItem(product.product_idx)}
                                    />
                                </td>
                                <td className="px-2 sm:w-1/2 max-w-[100px] truncate">{product.product_category?.category_name}</td>
                                <td className="px-2">{product.product_idx}</td>
                                <td className="sm:w-1/2 max-w-[100px]">
                                    <div className="flex items-center px-2 gap-2">
                                        {product.product_image && (
                                            <div className="h-9 w-9 bg-white rounded-lg overflow-hidden">
                                                {product.product_image?.file_name ? (
                                                    <img
                                                        src={`${api_uri}/${product.product_image.file_name}`}
                                                        alt={product.product_image.original_name}
                                                        className="w-full h-full object-contain"
                                                    />
                                                ) : null}
                                            </div>
                                        )}

                                        <p className="truncate">{product.product_name}</p>
                                    </div>
                                </td>
                                <td className="px-2">{product.product_amount?.toLocaleString()}원</td>
                                <td className="px-2 text-xs text-gray3">
                                    {showDeleted ? (product.update_date ?? "-") : product.reg_date}
                                </td>
                                {!showDeleted && (
                                    <td className="flex items-center justify-center h-[50px]">
                                        <Toggle
                                            disabled={level === 7}
                                            onToggle={e => {
                                                e.stopPropagation();
                                                handleChangeStatus(product.product_idx);
                                            }}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={product.status}
                                        />
                                    </td>
                                )}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={showDeleted ? 5 : 6} className="text-center">
                                <div className="flex flex-col items-center gap-5 py-4 mt-52">
                                    <Empty />
                                    <p className="text-grayicon text-lg">{showDeleted ? "삭제된 내역이 없습니다." : "등록된 내역이 없습니다."}</p>
                                </div>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default GoodsTable;
